<template>
  <div class="layout-footer">FREESH by PrimeVue & SAKAI</div>
</template>

<script setup></script>
